import { Component, computed, effect, inject, Input, input, output, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BlogService } from '../../services/blog.service';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ProfilesService } from '../../services/profiles.service';

@Component({
  selector: 'app-suppliers-sidebar',
  imports: [FormsModule],
  templateUrl: './suppliers-sidebar.html',
  styleUrl: './suppliers-sidebar.scss',
})
export class SuppliersSidebar {
  category = input<string | null>(null);
  initialTags = input<string[]>([]);

  onSearch = output<string>();
  onTagSelect = output<string>();

  isLoading = signal(true);
  router = inject(Router);

  blogService = inject(BlogService);
  profilesService = inject(ProfilesService);

  tags = signal<any>([]);
  selectedTag = signal<string | null>(null);
  showMoreTags = signal(false);

  @Input() query: string = '';

  constructor() {
    effect(() => {
      this.category();
      this.loadTags();
    });

    effect(() => {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          // this.loadRecentPosts();
        }
      });
    });
  }

  isInitialTag = computed(() => {
    const initial = this.initialTags();
    return (tagSlug: string) => initial.includes(tagSlug);
  });

  ngOnInit(): void {}

  async loadTags() {
    this.isLoading.set(true);
    try {
      const result = await this.profilesService.loadTabsByProfileType(
        'supplier'
      );
      this.tags.set(result);
    } catch (error) {
      console.error('Error loading tags', error);
    } finally {
      this.isLoading.set(false);
    }
  }

  onSearchEvent(event: Event) {
    event.preventDefault();
    this.onSearch.emit(this.query);
  }

  handleSelectedTag(tag: any) {

    if (this.selectedTag() === tag.id) {
      this.selectedTag.set(null);
      this.onTagSelect.emit('');
      return;
    }

    this.selectedTag.set(tag.id);
    this.onTagSelect.emit(tag.slug);
  }
}
